import React from "react";
import styled from "styled-components";
import MessageResenderMessageContent from "./MessageResenderMessageContent/MessageResenderMessageContent";
import MessageResenderMessages from "./MessageResenderMessages/MessageResenderMessages";
import MessageResenderOrders from "./MessageResenderOrders/MessageResenderOrders";
import MessageResenderSendButton from "./MessageResenderSendButton/MessageResenderSendButton";
import { MessageResenderSearchBar } from "./MessageResenderSearchBar/MessageResenderSearchBar";
import ModalScreen from "../ModalScreen/ModalScreen";
const StyledMessageResenderScreen = styled.div `
  height: calc(100% - 20px);
  width: 100%;
  background-color: white;
  overflow: hidden;
`;
const StyledModalScreenContent = styled.div `
  margin: 10px;
  background-color: white;
  height: 100%;
  width: 100%;
`;
const StyledModalScreenContentText = styled.div `
  white-space: pre-wrap;
  color: red;
`;
class MessageResenderScreen extends React.Component {
    constructor(props) {
        super(props);
        this.handleOrderRowClick = (event) => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { selectedOrderNumber: event.orderNumber, selectedMessageId: 0, ServerQueueMessages: [], LocalQueueMessages: [] })), () => {
                this.getOrderMessages(this.state.selectedOrderNumber);
            });
        };
        this.handleMessageRowClick = (event) => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { selectedMessageId: event.messageId })));
        };
        this.handleCheckboxChange = (event) => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { LocalQueueMessages: prevState.LocalQueueMessages.map(message => {
                    if (message.id === event.id) {
                        return Object.assign(Object.assign({}, message), { resend: event.isChecked });
                    }
                    else {
                        return message;
                    }
                }) })));
        };
        this.handlePayloadChange = (payload, id) => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { LocalQueueMessages: prevState.LocalQueueMessages.map(detail => {
                    if (detail.id === id) {
                        return Object.assign(Object.assign({}, detail), { payload: payload });
                    }
                    else {
                        return detail;
                    }
                }) })));
        };
        this.handleSendMessage = () => {
            let resendMessages = this.state.LocalQueueMessages.filter(m => {
                if (m.resend == true)
                    return m;
            });
            resendMessages.map(message => {
                fetch(`/sl3/rest/sent_message_management/resend_message/${message.id}`)
                    .catch(console.log);
            });
            alert("Resend message request sent to server.");
        };
        this.handleSearchStringsChange = (orderNumber, startDate, endDate) => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { searchOrderNumber: orderNumber || "", searchStartDate: new Date(startDate) || new Date(), searchEndDate: new Date(endDate) || new Date() })));
        };
        this.handleSearchButtonClick = () => {
            if (!this.validateSearchDate())
                return;
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { orderNumbers: [], selectedMessageId: 0, ServerQueueMessages: [], LocalQueueMessages: [] })), () => {
                if (this.state.searchOrderNumber === "") {
                    this.setState(prevState => (Object.assign(Object.assign({}, prevState), { isModalScreenVisible: true, modalScreenMessage: "Order number cannot be blank." })));
                    // this.getDateMessages();
                }
                else if (this.state.searchOrderNumber !== "") {
                    this.getOrderMessages(this.state.searchOrderNumber);
                }
            });
        };
        this.validateSearchDate = () => {
            let isSearchValid = true;
            let errorMessage = "Unable to retrieve messages. ";
            if (this.state.searchStartDate > new Date()) {
                isSearchValid = false;
                errorMessage += "Start time can not be in the future. ";
            }
            if (this.state.searchEndDate > new Date()) {
                isSearchValid = false;
                errorMessage += "End time can not be in the future. ";
            }
            if (this.state.searchStartDate > this.state.searchEndDate) {
                isSearchValid = false;
                errorMessage += "Start time can not be later than end time. ";
            }
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { isModalScreenVisible: !isSearchValid, modalScreenMessage: errorMessage })));
            return isSearchValid;
        };
        this.getDateMessages = () => {
            fetch(`/sl3/rest/sent_message_management/?startTime=${this.state.searchStartDate.toISOString()}&endTime=${this.state.searchEndDate.toISOString()}`)
                .then(res => res.json())
                .then((ServerQueueMessages) => {
                const queueMessages = Array.from(ServerQueueMessages);
                let orderNumbers = new Set(queueMessages.map(m => m.order_number));
                this.setState(prevState => (Object.assign(Object.assign({}, prevState), { orderNumbers: Array.from(orderNumbers), ServerQueueMessages: queueMessages, LocalQueueMessages: queueMessages.map(m => (Object.assign(Object.assign({}, m), { resend: false }))) })));
            })
                .catch(console.log);
        };
        this.getOrderMessages = (orderNumber) => {
            fetch(`/sl3/rest/sent_message_management/by_order_number/${orderNumber}?startTime=${this.state.searchStartDate.toISOString()}&endTime=${this.state.searchEndDate.toISOString()}`)
                .then(res => res.json())
                .then((ServerQueueMessages) => {
                const queueMessages = Array.from(ServerQueueMessages);
                let orderNumbers = new Set(queueMessages.map(m => m.order_number));
                this.setState(prevState => (Object.assign(Object.assign({}, prevState), { orderNumbers: Array.from(orderNumbers), ServerQueueMessages: queueMessages, LocalQueueMessages: queueMessages.map(m => (Object.assign(Object.assign({}, m), { resend: false }))) })));
            })
                .catch(console.log);
        };
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 90);
        this.state = {
            selectedOrderNumber: "",
            selectedMessageId: 0,
            orderNumbers: [],
            ServerQueueMessages: [],
            LocalQueueMessages: [],
            searchOrderNumber: "",
            searchStartDate: startDate,
            searchEndDate: endDate,
            isModalScreenVisible: false,
            modalScreenTitle: "",
            modalScreenMessage: ""
        };
    }
    render() {
        let localQueueMessages = this.state.LocalQueueMessages.find(m => m.id == this.state.selectedMessageId);
        return (React.createElement(StyledMessageResenderScreen, { className: "message-resender-screen-container" },
            React.createElement(MessageResenderSearchBar, { handleSearchStringsChange: this.handleSearchStringsChange, handleSearchButtonClick: this.handleSearchButtonClick, startDate: this.state.searchStartDate, endDate: this.state.searchEndDate }),
            React.createElement(MessageResenderSendButton, { handleSendMessage: this.handleSendMessage }),
            React.createElement(MessageResenderOrders, { orderNumber: this.state.orderNumbers, handleOrderRowClick: this.handleOrderRowClick }),
            React.createElement(MessageResenderMessages, { localQueueMessages: this.state.LocalQueueMessages, handleMessageRowClick: this.handleMessageRowClick, handleCheckboxChange: this.handleCheckboxChange }),
            React.createElement(MessageResenderMessageContent, { LocalQueueMessage: localQueueMessages, handlePayloadChange: this.handlePayloadChange }),
            React.createElement(ModalScreen, { isVisible: this.state.isModalScreenVisible, minDistanceFromEdge: 500, maxWidth: 500, maxHeight: 200, titleText: "", isBlocking: false, onDismiss: () => this.setState(prevState => (Object.assign(Object.assign({}, prevState), { isModalScreenVisible: false, modalScreenMessage: "" }))) },
                React.createElement(StyledModalScreenContent, { className: "modal-screen-content" },
                    React.createElement(StyledModalScreenContentText, { className: "modal-screen-content-text" }, this.state.modalScreenMessage)))));
    }
    componentDidMount() {
    }
}
export default MessageResenderScreen;
